import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, watch} from "vue";
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import { useTranslations } from "@/hooks/useTranslations";
import VIngredientsDisplayNames from "@/components/vIngredientsDisplayNames.vue";
import VUSContainsPercentOfForm from "@/components/vUSContainsPercentOfForm.vue";
import VToggleSwitch from "@/components/vToggleSwitch.vue";
import {ExportLabelState} from "@/models/NutritionLabels/ExportLabelState";
import {Recipe} from "@/models/Recipes/Recipe";
import IngredientDisplay from "@/models/Ingredient/IngredientDisplay";
import {splitLanguages} from "@/models/NutritionLabels/v2/Helpers";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {ExportLabelState2} from "@/models/NutritionLabels/v2/ExportLabelState2";


export default /*#__PURE__*/_defineComponent({
  __name: 'IngredientConfiguration',
  props: {
    model: null,
    language: null,
    recipe: null,
    ingredientAndSubRecipeDisplays: null,
    subRecipeDisplays: null,
    getChangedDisplayNames: null
  },
  emits: [
  "fetch-preview",
  "toggle-subrecipes",
  "reset-ingredient-display",
  "reset-subrecipe-display",
  "update:model",
],
  setup(__props: any, { emit }) {

const props = __props as {
  model: ExportLabelState;
  language: string;
  recipe: Recipe;
  ingredientAndSubRecipeDisplays: IngredientDisplay[];
  subRecipeDisplays: IngredientDisplay[];
  getChangedDisplayNames: any;
};





const translations = useTranslations();
const localModel = ref({ ...props.model });

// Sync prop
watch(
  () => props.model,
  (newVal) => {
    localModel.value = { ...newVal };
  },
  { deep: true }
);

// Emit updates
watch(
  localModel,
  (val) => {
    emit("update:model", val);
  },
  { deep: true }
);

// Emit events for actions
function emitFetchPreview() {
  emit("fetch-preview");
}

function emitToggleSubrecipes() {
  emit("toggle-subrecipes");
}

function emitResetIngredientDisplay() {
  emit("reset-ingredient-display");
}

function emitResetSubrecipeDisplay() {
  emit("reset-subrecipe-display");
}

return { __sfc: true,props, emit, translations, localModel, emitFetchPreview, emitToggleSubrecipes, emitResetIngredientDisplay, emitResetSubrecipeDisplay, CollapsableCard, VIngredientsDisplayNames, VUSContainsPercentOfForm, VToggleSwitch }
}

})